import React, { useState, useEffect } from "react";
import arrowup from "../Images/arrowup.png";
import { useTranslation } from "react-i18next";
export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setIsHovered(false);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    isVisible && (
      <div
        onClick={scrollToTop}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          cursor: "pointer",
          zIndex: 1000,
          backgroundColor: isHovered ? "black" : "transparent", // Change bg color on hover
          padding: "10px", // Padding around the image
          borderRadius: "50%", // Circular shape
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.06)", // Adding a shadow
          padding: 15,
        }}
      >
        <img
          src={arrowup}
          alt="Scroll to top"
          style={{
            display: "block", // Ensures the image takes the space within the div
            width: "25px", // Adjust the size as needed
            height: "25px",
            filter: isHovered ? "invert(1)" : "invert(0)", // Invert image color on hover
          }}
        />
      </div>
    )
  );
}
